import styled, { css } from "styled-components";

export const ParagraphWrapper = styled.div<{
  width: string;
  ellipsis: boolean;
  clearable: boolean;
  isPlaceholder?: boolean;
  fitParent?: boolean;
}>`
  display: inline-block;
  position: relative;
  width: ${(p) => p.width};
  max-width: ${(p) => p.width};
  ${(p) =>
    p.ellipsis &&
    css`
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  ${(p) => {
    if (!p.clearable) return;
    const width = p.width.includes("px") ? `calc(${p.width})` : p.width;
    return css`
      padding-right: 12px;
      width: ${width};
      max-width: ${width};
    `;
  }}
  .clear-icon {
    position: absolute;
    right: 0px;
    top: 50%;
    cursor: pointer;
    transform: translate(0, -50%);
  }
  ${(p) =>
    p.isPlaceholder &&
    css`
      color: #6c767f;
    `}
  ${(p) =>
    p.fitParent &&
    css`
      height: 100%;
      display: flex;
      align-items: center;
    `}
`;
